module.exports = __webpack_public_path__ + "resource/img/close.e26c7086.svg";